export const formatNumber = number => new Intl.NumberFormat('ru-RU').format(number)

export const extractFields = function (form) {
    let fields = {}

    new FormData(form).forEach((value, key) => {
        if (_.has(fields, key)) {
            if (!_.isArray(fields[key])) {
                fields[key] = [fields[key]];
            }

            fields[key].push(value);
        } else {
            fields[key] = value
        }
    })

    return fields
}

export const formSetErrors = function ($form, errors = []) {
    setErrors($form.find('.input-alert'), errors);
}

export const setErrors = function ($node, errors = []) {
    let messages = [];

    errors.forEach(function (error) {
        messages.push(error.message);
    });

    console.error(messages);

    $node.html(messages.join('<br>'));
}

const fallbackCopyTextToClipboard = function (text) {
    const textArea = document.createElement("textarea");
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        const successful = document.execCommand('copy');
        const msg = successful ? 'successful' : 'unsuccessful';
        console.log('Fallback: Copying text command was ' + msg);
    } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
    }

    document.body.removeChild(textArea);
}
export const copyTextToClipboard = function (text) {
    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text);
        return;
    }
    navigator.clipboard.writeText(text).then(function () {
        console.log('Async: Copying to clipboard was successful!');
    }, function (err) {
        console.error('Async: Could not copy text: ', err);
    });
}